<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
defineProps<{
  positionLabel?: string
  professionLabel?: string
}>()
</script>

<template>
  <div class="form-section--2-cols">
    <Input
      id="professional-info-position"
      name="position"
      :label="positionLabel ?? t('tocco.registration.conference.personalInfo.position')"
      :required="true"
    />
    <Input
      id="professional-info-profession"
      name="profession"
      :label="professionLabel ?? t('tocco.registration.conference.personalInfo.profession')"
      :required="true"
    />
  </div>
</template>
